import { writable } from 'svelte/store'
import { hiringApi } from 'src/api'

export const fetchPreferredTime = async uid => {
  const { data: { preferred_time } } = await hiringApi.get(`/public/preferred-time/${uid}/`)
  PreferredTime.update(() => preferred_time || [])
}

export const submitPreferredTime = ({ uid, preferred_time }) => (
  hiringApi.patch(`/public/preferred-time/${uid}/`, { preferred_time })
)

export const PreferredTime = writable([])

export const preferredTimeTpl = { date_range: [], time_range: [] }
